import { RegionEnum } from "./enum/RegionEnum";

export default class SubscriptionRequestDTO {

  public name: string;
  public email: string;
  public regions: Array<RegionEnum>;
  public trainings: Array<string>;

    constructor(name: string, email: string, regions: Array<RegionEnum>, trainings: Array<string>) {
    this.name = name;
    this.email = email;
    this.regions = regions;
    this.trainings = trainings;
  }


}
